export function arrayCheck(arg) {
  return Array.isArray(arg) ? arg : [];
}
